module.exports = __webpack_public_path__ + "static/media/body_fat_percentage.dca147b0.svg";